import fvSubassembly from "../fvSubassembly"
export default class fvErrorObj extends fvSubassembly {
    constructor(sContent,parent,system,callback){
        super(sContent,parent,system);
        this.create();
        if(this.isDelayedWaiting){
            this.complete = callback;
        }else{
            callback(this);
        }
    }
    onDraw(){
        
    }
    Render () {
        
    }
    roundRect() {}
  
    //判断如果圆角最大值不能超过宽高的一半
    changeGrond(obj){
        
    }

}


// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvErrorObj.js